import { render, staticRenderFns } from "./companyIncome.vue?vue&type=template&id=e825909c&scoped=true&"
import script from "./companyIncome.vue?vue&type=script&lang=js&"
export * from "./companyIncome.vue?vue&type=script&lang=js&"
import style0 from "./companyIncome.vue?vue&type=style&index=0&id=e825909c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e825909c",
  null
  
)

export default component.exports